import { Tabulator, FilterModule } from 'tabulator-tables';
import { INewPartner } from '../../models/partner.interface';

/**
 * Searches a table and returns a value givin the input. This function also
 * handles clearing the search input and hiding the clear button.
 * 
 * @param {HTMLInputElement} searchElement the HTML input element
 * @param {Tabulator} table the table being searched
 * 
 */
const tableSearchInput = (searchElement: HTMLInputElement, table: Tabulator) => {
  const clearSearch = document.querySelector('.aafp_text-field-clear') as HTMLElement;
  const toggleCont = document.querySelector('.aafp_text-field') as HTMLElement;
  Tabulator.registerModule([ FilterModule ]);

  let timeout: NodeJS.Timeout;

  const handleSearch = () => {
    const search = searchElement.value;
    const filters = table.getColumns().map(column => ({
      field: column.getField(),
      type: 'like',
      value: search
    }));

    table.setFilter([filters]);
  };

  const handleFocus = () => {
    clearSearch.style.display = 'block';
  };

  const handleClear = () => {
    searchElement.value = '';
    clearSearch.style.display = 'none';
    table.clearFilter(true);
  };

  searchElement.addEventListener('keyup', () => {
    clearTimeout(timeout);
    timeout = setTimeout(handleSearch, 300);
  });

  searchElement.addEventListener('focus', handleFocus);

  document.addEventListener('click', (event: any) => {
    if (toggleCont !== event.target && !toggleCont.contains(event.target) && searchElement.value === '') {
      clearSearch.style.display = 'none';
    }
  });

  clearSearch.addEventListener('click', handleClear);
}

/**
 * Function to parse parnter data for dropdown multi select.
 * 
 * @param {object} data the api response data
 */
const parsePartnerDataForSort = (data: INewPartner[]) => {
  const partnerList = document.querySelector('.aafp_filter-partners-list') as HTMLElement;
  const fragment = document.createDocumentFragment();

  const pList = data.map((key: INewPartner) => {
    return { 'ID': key.partnerID, 'Name': key.partnerName };
  });

  for (const { ID, Name } of pList) {
    const div = document.createElement('div');
    div.classList.add('aafp_checkbox-container');

    const label = document.createElement('label');
    label.classList.add('form-check-label');
    label.htmlFor = `defaultCheck${ID}`;
    label.textContent = Name;

    const input = document.createElement('input');
    input.classList.add('form-check-input', 'aafp_part', 'table-filter-clear');
    input.type = 'checkbox';
    input.value = ID!;
    input.id = `defaultCheck${ID}`;

    const span = document.createElement('span');
    span.classList.add('aafp_checkmark');

    label.appendChild(input);
    label.appendChild(span);
    div.appendChild(label);
    fragment.appendChild(div);
  }

  partnerList.appendChild(fragment);
}

/**
 * Returns a list of unique values
 * 
 * @param {object[]} list an array of objects that all duplicates need to be removed.
 * @param {string} field the field that needs to be unique
 * 
 * @returns array
 */
const getUniqueValues = (list: object[], field: string) => {
  return [... new Map(list.map((item: any) => [item[field], item])).values()]
}

export { tableSearchInput, parsePartnerDataForSort, getUniqueValues };